export const INTRODUCTION_VIDEO_NOTIFICATION_KEY = "introduction-video";
export const DESKTOP_APP_NOTIFICATION_KEY = "desktop-app";
